import { useAuthStore } from '../store/authStore';

export function useCurrentUser() {
  const userId = useAuthStore((s) => s.userId);
  const role = useAuthStore((s) => s.role);
  const assignedAccountIds = useAuthStore((s) => s.assignedAccountIds);
  const isLoading = useAuthStore((s) => s.isLoading);

  return {
    userId,
    role,
    assignedAccountIds,
    isAdmin: role === 'admin',
    isLoading,
  };
}
